<script setup>
import { ref, computed } from 'vue';

import ComboBox from 'dashboard/components-next/combobox/ComboBox.vue';

// A ComboBox that matches options by their catalog aliases as well as their
// displayed label, so e.g. "benz" finds "Mercedes-Benz". It layers keyword
// matching on top of the base ComboBox through its existing api-results hook
// (skip the built-in local filter, supply the matches ourselves) instead of
// modifying the shared OSS component.
const props = defineProps({
  // ComboBox options; each option may carry a `keywords` array of alias
  // strings used for matching in addition to its `label`.
  options: {
    type: Array,
    default: () => [],
  },
});

defineOptions({ inheritAttrs: false });

const search = ref('');

const filteredOptions = computed(() => {
  const term = search.value.trim().toLowerCase();
  if (!term) return props.options;

  return props.options.filter(option =>
    [option.label, ...(option.keywords || [])].some(text =>
      String(text).toLowerCase().includes(term)
    )
  );
});
</script>

<template>
  <ComboBox
    v-bind="$attrs"
    :options="filteredOptions"
    use-api-results
    @open="search = ''"
    @search="search = $event"
  />
</template>
